import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function AdminGate({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="page-loading">Cargando…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (user.role !== 'admin') {
    return (
      <div className="page-error">
        <h1>Acceso restringido</h1>
        <p>Tu cuenta ({user.email}) no tiene rol de administrador.</p>
      </div>
    );
  }
  return <>{children}</>;
}
